var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChemical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#db011c",
  "data-name": "Group 32881"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32880"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 62.951A22.951 22.951 0 1 1 62.951 40 22.977 22.977 0 0 1 40 62.951m0-43.934a20.984 20.984 0 1 0 20.984 20.984A21.01 21.01 0 0 0 40 19.016Z",
  "data-name": "Path 19149"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32879"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.229 61.543 44.146-44.472 1.396 1.385L18.625 62.93z",
  "data-name": "Rectangle 26179"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.234 18.45 1.396-1.385 44.135 44.483-1.396 1.385z",
  "data-name": "Rectangle 26180"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M80 80H0V0h80ZM1.311 78.692h77.377V1.311H1.311Z",
  "data-name": "Path 19150"
}))));
export default SvgChemical;